import React from 'react'
import styled, { keyframes } from 'styled-components'

const pop = keyframes`
  0% { transform: scale(0) rotate(-45deg); opacity: 0; }
  80% { transform: scale(1) rotate(0deg); opacity: 1; }
  90% { transform: scale(0.93); }
  100% { transform: scale(0.95); }
`

const beat = keyframes`
  0% { transform: scale(0.95); }
  60% { transform: scale(0.95); fill: #ffffff; }
  80% { transform: scale(1.1); fill: #25dffe; }
  100% { transform: scale(0.95); fill: #ffffff; }
`

const closing = keyframes`
  0% { transform: scale(0.95); }
  100% { transform: scale(0) rotate(45deg); opacity: 0; }
`

const EmbraceHeartIconSVGContainer = styled.svg`
  display: block;

  flex-shrink: 1;

  animation: ${beat} 0.8s ease-in-out forwards;

  min-height: 0;
  min-width: 0;
  max-height: 100%;
  max-width: 100%;
  height: 75px;
  width: 75px;

  #person-1,
  .animate {
    transform-origin: center;
    transform: scale(0);
    animation: ${pop} 0.6s ease-in forwards;
  }

  #person-2,
  .animate {
    transform-origin: center;
    transform: scale(0);
    animation: ${pop} 0.6s 0.2s ease-in forwards;
  }

  #person-3,
  .animate {
    transform-origin: center;
    transform: scale(0);
    animation: ${pop} 0.6s 0.4s ease-in forwards;
  }

  #heart,
  .animate {
    transform-origin: center;
    transform: scale(0.95);
    animation: ${beat} 0.8s 0.8s ease-in-out forwards;
  }

  #person-1-close,
  .animate {
    transform-origin: center;
    animation: ${closing} 0.4s 1.5s ease-in forwards;
  }

  #person-2-close,
  .animate {
    transform-origin: center;
    animation: ${closing} 0.4s 1.6s ease-in forwards;
  }

  #person-3-close,
  .animate {
    transform-origin: center;
    animation: ${closing} 0.4s 1.7s ease-in forwards;
  }
`

export const EmbraceHeartIcon: React.FC = () => {
  return (
    <EmbraceHeartIconSVGContainer
      data-name="Tabia Embracer Heart"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 102.11 104"
    >
      <g id="embracer-heart-loading">
        <g id="embracer-heart">
          <g id="together" className="animate">
            <g id="person-3" className="animate">
              <g id="person-3-close" className="animate">
                <path
                  id="person"
                  fill="#0579fd"
                  d="M52.57,52c-.05,10.01-4.33,20.07-13.03,27.52-5.31,4.55-11.74,7.46-18.48,8.67-9.02,1.62-15.09-8.38-9.1-15.02,.8-.89,1.57-1.83,2.29-2.81,4.01-5.48,6.13-11.89,6.36-18.35h0c-.23-6.46-2.35-12.87-6.36-18.35-.72-.99-1.49-1.93-2.29-2.81-5.99-6.64,.08-16.64,9.1-15.02,6.74,1.21,13.18,4.12,18.48,8.67,8.7,7.45,12.98,17.51,13.03,27.52Zm-35.43,0c0-4.74-3.84-8.57-8.57-8.57S0,47.26,0,52s3.84,8.57,8.57,8.57,8.57-3.84,8.57-8.57Z"
                />
                <path
                  id="cutting"
                  fill="#233cfe"
                  d="M39.54,79.52c-1.54,1.32-3.19,2.49-4.9,3.53,.05-2,.23-4.01,.61-6,2.11-11.26,8.67-19.99,17.32-25.05-.05,10.01-4.33,20.07-13.03,27.52Zm13.03-27.52c-.05-10.01-4.33-20.07-13.03-27.52-1.54-1.32-3.19-2.49-4.9-3.53,.05,2,.23,4.01,.61,6,2.11,11.26,8.67,19.99,17.32,25.05Z"
                />
              </g>
            </g>
            <g id="person-2" className="animate">
              <g id="person-2-close" className="animate">
                <path
                  id="person"
                  data-name="person"
                  fill="#0579fd"
                  d="M52.57,52c8.7-4.96,19.54-6.28,30.35-2.48,6.59,2.32,12.33,6.44,16.75,11.67,5.92,7,.29,17.26-8.46,15.39-1.17-.25-2.37-.44-3.58-.58-6.75-.74-13.36,.64-19.07,3.67h0c-5.48,3.43-9.97,8.47-12.71,14.69-.49,1.12-.92,2.25-1.29,3.39-2.76,8.51-14.45,8.25-17.56-.37-2.32-6.45-3.02-13.47-1.74-20.34,2.11-11.26,8.67-19.99,17.32-25.05Zm17.71,30.68c-4.1,2.37-5.51,7.61-3.14,11.71,2.37,4.1,7.61,5.51,11.71,3.14,4.1-2.37,5.51-7.61,3.14-11.71s-7.61-5.51-11.71-3.14Z"
                />
                <path
                  id="cutting-2"
                  data-name="cutting"
                  fill="#233cfe"
                  d="M39.54,79.52c-1.54,1.32-3.19,2.49-4.9,3.53,.05-2,.23-4.01,.61-6,2.11-11.26,8.67-19.99,17.32-25.05-.05,10.01-4.33,20.07-13.03,27.52Zm13.03-27.52c8.7,4.96,19.54,6.28,30.35,2.48,1.91-.67,3.75-1.52,5.5-2.48-1.76-.96-3.59-1.8-5.5-2.48-10.81-3.81-21.65-2.49-30.35,2.48Z"
                />
              </g>
            </g>
            <g id="person-1" className="animate">
              <g id="person-1-close" className="animate">
                <path
                  id="person"
                  data-name="person"
                  fill="#0579fd"
                  d="M52.57,52c-8.65-5.05-15.21-13.78-17.32-25.05-1.29-6.87-.59-13.9,1.74-20.34,3.11-8.63,14.8-8.88,17.56-.37,.37,1.14,.8,2.27,1.29,3.39,2.74,6.21,7.23,11.25,12.71,14.69h0c5.71,3.03,12.32,4.4,19.07,3.67,1.22-.13,2.41-.33,3.58-.58,8.75-1.87,14.37,8.39,8.46,15.39-4.42,5.23-10.15,9.35-16.75,11.67-10.81,3.81-21.65,2.49-30.35-2.48Zm17.71-30.68c4.1,2.37,9.34,.96,11.71-3.14s.96-9.34-3.14-11.71c-4.1-2.37-9.34-.96-11.71,3.14s-.96,9.34,3.14,11.71Z"
                />
                <path
                  id="cutting-3"
                  data-name="cutting"
                  fill="#233cfe"
                  d="M35.26,26.95c-.37-1.99-.56-4-.61-6,1.71,1.04,3.36,2.21,4.9,3.53,8.7,7.46,12.98,17.51,13.03,27.52-8.65-5.05-15.21-13.78-17.32-25.05Zm17.32,25.05c8.7,4.96,19.54,6.28,30.35,2.48,1.91-.67,3.75-1.52,5.5-2.48-1.76-.96-3.59-1.8-5.5-2.48-10.81-3.81-21.65-2.49-30.35,2.48Z"
                />
              </g>
            </g>
          </g>
          <path
            id="heart"
            className="animate"
            fill="#fff"
            d="M69.8,56.64l-14.97,14.48c-1.2,1.16-3.11,1.16-4.31,0l-14.97-14.48c-4.73-4.7-4.73-12.33,0-17.04,4.73-4.7,12.4-4.7,17.13,0,4.73-4.7,12.4-4.7,17.13,0,4.73,4.7,4.73,12.33,0,17.04Z"
          />
        </g>
      </g>
    </EmbraceHeartIconSVGContainer>
  )
}
